<template>
  <el-table-column
    prop="type"
    label="Esemény"
    width="220"
    show-overflow-tooltip
  >
    <template slot-scope="scope">
      <el-tag
        size="small"
        :type="scope.row.is_storno == 1 ? 'danger' : getType(scope.row.type).tag"
      >
        {{ getType(scope.row.type).label }} <span v-if="scope.row.is_storno == 1"> (sztornó)</span>
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'type',
  methods: {
    getType(type) {
      switch (type) {
        case 'customerSale':
          return {
            label: 'Központi eladás',
            tag: 'success',
          };
          break;
        case 'customerOrder':
          return {
            label: 'Központi rendelés',
            tag: 'success',
          };
          break;
        case 'representativeOrder':
          return {
            label: 'Raktárközi megrendelés',
            tag: 'success',
          };
          break;
        case 'inwardHandling':
          return {
            label: 'Bevételezés',
            tag: 'primary',
          };
        case 'representativeSale':
          return {
            label: 'Képviselői eladás',
            tag: 'success',
          };
        case 'representativePlacement':
          return {
            label: 'Képviselői kihelyezés',
            tag: 'success',
          };
          break;
        case 'customerReturnOrder':
          return {
            label: 'Vevői visszáru',
            tag: 'primary',
          };
          break;
        case 'representativeDelivery':
          return {
            label: 'Képviselői bevételezés',
            tag: 'success',
          };
          break;
        case 'packing':
          return {
            label: 'Csomagolás',
            tag: 'success',
          };
          break;
        case 'representativeDrop':
          return {
            label: 'Képviselői leadás',
            tag: 'primary',
          };
          break;
        case 'declutter':
          return {
            label: 'Selejtezés',
            tag: 'primary',
          };
          break;
        case 'stockTakingDifference':
          return {
            label: 'Leltáreltérés',
            tag: 'primary',
          };
          break;
        case 'representativeTransfer':
          return {
            label: 'Képviselői átadás (-)',
            tag: 'primary',
          };
          break;
        case 'representativeReceive':
          return {
            label: 'Képviselői átadás (+)',
            tag: 'primary',
          };
          break;
        case 'supplierReturnOrder':
          return {
            label: 'Beszállítói visszáru',
            tag: 'primary',
          };
          break;
      }
    }
  },
};
</script>
